import cn from "classnames";
import { Pagination as P } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className, items, perPage, page, setPage }) {
  return (
    <P className={cn(className, classes.Pagination)}>
      {page > 1 && <P.Prev className="prev" onClick={() => setPage(page - 1)} />}
      {new Array(Math.ceil(items.length / perPage)).fill(null).map((_, idx) => (
        <P.Item className="item" active={page === idx + 1} onClick={() => setPage(idx + 1)}>
          {idx + 1}
        </P.Item>
      ))}
      {page < Math.ceil(items.length / perPage) && (
        <P.Next className="next" onClick={() => setPage(page + 1)} />
      )}
    </P>
  );
}
